<script>
    export let media
    export let remove
    let player

    $: fileSize =
        media.size > 1024
            ? media.size > 1048576
                ? Math.round(media.size / 1048576) + 'mb'
                : Math.round(media.size / 1024) + 'kb'
            : media.size + 'b'

    function play() {
        player.play()
    }

    function pause() {
        player.pause()
    }
</script>

<li
    on:mouseenter={play}
    on:mouseleave={pause}
    class="col-span-1 flex shadow-sm rounded-md">
    <div
        class="flex-shrink-0 flex items-center justify-center w-20 bg-green-screen text-white text-sm leading-5 font-medium rounded-l-md">
        <video bind:this={player} src={media.url} loop class="">
            <track kind="captions" /></video>
    </div>
    <div
        class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
        <div class="flex-1 px-4 py-2 text-sm leading-5 truncate">
            <span
                class="text-gray-900 font-medium hover:text-gray-600 transition ease-in-out duration-150">
                {media.id}
            </span>
            <p class="text-gray-500">{fileSize}</p>
        </div>
        <div class="flex-shrink-0 pr-2">
            <button
                class="w-8 h-8 inline-flex items-center justify-center text-gray-400 rounded-full bg-transparent hover:text-gray-500 focus:outline-none focus:text-gray-500 focus:bg-gray-100 transition ease-in-out duration-150">
                <i
                    class="gg-remove"
                    on:click={() => {
                        remove(media.id)
                    }} />
            </button>
        </div>
    </div>
</li>
